module.exports = __webpack_public_path__ + "img/oportunidade.cb421086.png";